import { DashboardLayout } from "components/Dashboard/DashboardLayout";
import { ChartTileSkeleton, TwoChartTileSkeleton } from "components/Dashboard/OverviewSkeleton";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { Suspense } from "react";

import { OverviewGlobalFilters } from "./OverviewGlobalFilters";
import { FacilitiesByGeneratorStatusTile } from "./Tiles/FacilitiesByGeneratorStatusTile";
import { ManagementMethodTile } from "./Tiles/ManagementMethodTile";
import { TotalWasteTile } from "./Tiles/TotalWasteTile";
import { TsdfTile } from "./Tiles/TsdfTile";
import { VendorTile } from "./Tiles/VendorTile";
import { WasteOverviewContext } from "./WasteOverviewContext";

export function WasteOverview() {
  useBreadcrumb({ label: "Waste Overview" });
  return (
    <Suspense
      fallback={
        <>
          <TwoChartTileSkeleton height={55} />
          <ChartTileSkeleton height={18} />
          <TwoChartTileSkeleton height={20} />
          <ChartTileSkeleton height={20} />
        </>
      }
    >
      <WasteOverviewContext>
        <OverviewGlobalFilters />
        <DashboardLayout>
          <Suspense fallback={<TwoChartTileSkeleton height={55} />}>
            <FacilitiesByGeneratorStatusTile />
          </Suspense>
          <Suspense fallback={<ChartTileSkeleton height={18} />}>
            <TotalWasteTile />
          </Suspense>
          <Suspense fallback={<TwoChartTileSkeleton height={20} />}>
            <TsdfTile />
            <VendorTile />
          </Suspense>
          <Suspense fallback={<ChartTileSkeleton height={20} />}>
            <ManagementMethodTile />
          </Suspense>
        </DashboardLayout>
      </WasteOverviewContext>
    </Suspense>
  );
}
